import { ElementRef } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "Angular/features/directives/image/image.directive";
/**
 * Password Reveal Component
 *
 * Required Attributes:
 *    @ passwordElementId: Id of the password element
 */
export class PasswordRevealComponent {
    constructor(eltRef) {
        this.eltRef = eltRef;
        this.passwordElementId = eltRef.nativeElement.getAttribute('passwordElementId');
        this.showPassword = false; // pragma: allowlist secret
    }
    changePassInputType() {
        this.showPassword = !this.showPassword; // pragma: allowlist secret
        const passwordElement = document.getElementById(this.passwordElementId);
        if (passwordElement === null) {
            return;
        }
        if (this.showPassword) {
            passwordElement.type = 'text';
        }
        else {
            passwordElement.type = 'password';
        }
    }
}
PasswordRevealComponent.ɵfac = function PasswordRevealComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PasswordRevealComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
PasswordRevealComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PasswordRevealComponent, selectors: [["ycn-password-reveal"]], standalone: false, decls: 6, vars: 4, consts: [[1, "field-input-group-actions"], [1, "btn", "btn-transparent", "btn-clear", 3, "click"], ["tooltip", "", "tooltip-title", "Show", 3, "hidden"], ["ycnImage", "", 3, "imageSrc"], ["tooltip", "", "tooltip-title", "Hide", 3, "hidden"]], template: function PasswordRevealComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "a", 1);
        i0.ɵɵlistener("click", function PasswordRevealComponent_Template_a_click_1_listener() { return ctx.changePassInputType(); });
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵelement(3, "img", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵelement(5, "img", 3);
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("hidden", ctx.showPassword);
        i0.ɵɵadvance();
        i0.ɵɵproperty("imageSrc", "accounts/images/password-show.png");
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", !ctx.showPassword);
        i0.ɵɵadvance();
        i0.ɵɵproperty("imageSrc", "accounts/images/password-no-show.png");
    } }, dependencies: [i1.ImageDirective], encapsulation: 2 });
